import merge from 'lodash/merge';
import { i18nString } from 'typesafe-i18n';

import { defaultTranslations } from '@/modules/common';

type Locale = keyof typeof defaultTranslations;

export async function loadTranslations(locale: string, tenant: string) {
  try {
    // Custom i18nString formatters
    const formatters = {};
    // Initialize i18nString with locale and formatters
    const LLL = i18nString(locale, formatters);
    window.LLL = (...args: Parameters<ReturnType<typeof i18nString>>) => {
      if (!args?.[0]) {
        return '';
      }
      return LLL(...args);
    };

    const currentDate = new Date().toISOString();
    let response = await fetch(
      `https://storage.googleapis.com/saywhatt-chat/translations/${tenant}/${locale}.json?v=${currentDate}`
    );
    if (response.status === 404 && locale !== 'en') {
      // selected translation not found, try to load en
      response = await fetch(
        `https://storage.googleapis.com/saywhatt-chat/translations/${tenant}/en.json?v=${currentDate}`
      );
    }
    if (!response.ok) {
      return {
        error: `Failed to load translations for locale ${locale}: ${response.statusText}`,
        translations: defaultTranslations[locale as Locale] ?? defaultTranslations['en'],
      };
    }
    const translations = await response.json();

    return {
      translations: merge({}, defaultTranslations[locale as Locale] ?? defaultTranslations['en'], translations),
    };
  } catch (error) {
    console.error('Error loading translations:', error);
    return {
      error: `Error loading translations for locale ${locale}: ${error instanceof Error ? error.message : 'Unknown error'}`,
      translations: defaultTranslations[locale as Locale] ?? defaultTranslations['en'],
    };
  }
}
